<template>
  <div class="page-plan-edit">
    <el-form ref="form" label-position="top" size="small">
      <el-row :gutter="15">
        <el-col :span="10">
          <el-form-item label="Name">
            <el-input v-model="planData.name" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="Status">
            <el-select class="content" size="small" v-model="planData.is_published" style="width: 100%;">
              <el-option key="1" label="Active" :value="1"></el-option>
              <el-option key="2" label="Pending" :value="0"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="20">
          <el-form-item label="Features">
            <div class="features-container">
              <div class="features-header">
                <div class="header-col col-name">
                  <span>Active Features</span>
                </div>
                <div class="header-col col-action">
                  <span>Enable</span>
                </div>
              </div>
              <div class="features-list">
                <div class="feature-item">
                  <div class="feature-col col-name">
                    <span>Listening Guide</span>
                  </div>
                  <div class="feature-col col-action">
                    <el-switch v-model="planData.listening_guide.is_enable" active-color="#A5C2CB" />
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-col col-name">
                    <span>Discography</span>
                  </div>
                  <div class="feature-col col-action">
                    <el-switch v-model="planData.discography.is_enable" active-color="#A5C2CB" />
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-col col-name">
                    <span>Frequency Graphs</span>
                  </div>
                  <div class="feature-col col-action">
                    <el-switch v-model="planData.frequency_graphs.is_enable" active-color="#A5C2CB" />
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-col col-name">
                    <span>Tech Specs</span>
                  </div>
                  <div class="feature-col col-action">
                    <el-switch v-model="planData.tech_specs.is_enable" active-color="#A5C2CB" />
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-col col-name">
                    <span>Images</span>
                  </div>
                  <div class="feature-col col-action">
                    <el-switch v-model="planData.images.is_enable" active-color="#A5C2CB" />
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-col col-name">
                    <span>Products in Player</span>
                  </div>
                  <div class="feature-col col-action">
                    <el-select size="mini" v-model="planData.products_in_player.max_num" style="width: 150px;" placeholder=" ">
                      <el-option key="1" label="5 maximum" :value="5"></el-option>
                      <el-option key="2" label="No limit" :value="99999"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-col col-name">
                    <span>Other Brands Products</span>
                  </div>
                  <div class="feature-col col-action">
                    <el-switch v-model="planData.other_brands_products.is_enable" active-color="#A5C2CB" />
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-col col-name">
                    <span>ATK Songs</span>
                  </div>
                  <div class="feature-col col-action">
                    <el-select size="mini" v-model="planData.atk_songs.max_num" style="width: 150px;" placeholder=" ">
                      <el-option key="1" label="3 maximum" :value="3"></el-option>
                      <el-option key="2" label="No limit" :value="99999"></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="feature-item">
                  <div class="feature-col col-name">
                    <span>My Audio</span>
                  </div>
                  <div class="feature-col col-action">
                    <el-switch v-model="planData.my_audio.is_enable" active-color="#A5C2CB" />
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-form-item>
          <el-button class="el-btn-blue" @click="updatePlan" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button @click="returnBack">CANCEL</el-button>
        </el-form-item>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { reactive } from 'vue'
export default {
  name: 'PlanEdit',
  props: {
  },
  emits: [],
  components: {
  },
  data () {
    const flagLoading = reactive({
      save: false
    })
    const flagVisible = reactive({
    })
    const actionItems = reactive({
    })
    const planData = {
      listening_guide: {},
      discography: {},
      frequency_graphs: {},
      tech_specs: {},
      images: {},
      products_in_player: {},
      atk_songs: {},
      other_brands_products: {},
      my_audio: {}
    }
    return {
      planId: this.$route.params.id,
      plan: {},
      planData,
      flagLoading,
      flagVisible,
      actionItems
    }
  },
  created: function () {
    this.getPlan()
  },
  mounted () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getPlan: function () {
      const url = `/api/v1/atk_player/admin/subscriptions/${this.planId}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          const data = res.data
          that.plan = data
          const planData = {}
          planData.name = data.name
          planData.is_published = data.is_published
          planData.listening_guide = { is_enable: data.listening_guide.is_enable === 1 }
          planData.discography = { is_enable: data.discography.is_enable === 1 }
          planData.frequency_graphs = { is_enable: data.frequency_graphs.is_enable === 1 }
          planData.tech_specs = { is_enable: data.tech_specs.is_enable === 1 }
          planData.images = { is_enable: data.images.is_enable === 1 }
          planData.products_in_player = { max_num: data.products_in_player.max_num }
          planData.atk_songs = { max_num: data.atk_songs.max_num }
          planData.other_brands_products = { is_enable: data.other_brands_products.is_enable === 1 }
          planData.my_audio = { is_enable: data.my_audio.is_enable === 1 }
          that.planData = planData
        } else {
          console.error('getPlan', res.msg)
        }
      }).catch(function (err) {
        console.error('getPlan', err)
      })
    },
    updatePlan: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player/admin/subscriptions/${this.planId}`
      const that = this
      this.plan.name = this.planData.name
      this.plan.is_published = this.planData.is_published
      this.plan.listening_guide = { is_enable: this.planData.listening_guide.is_enable ? 1 : 0 }
      this.plan.discography = { is_enable: this.planData.discography.is_enable ? 1 : 0 }
      this.plan.frequency_graphs = { is_enable: this.planData.frequency_graphs.is_enable ? 1 : 0 }
      this.plan.tech_specs = { is_enable: this.planData.tech_specs.is_enable ? 1 : 0 }
      this.plan.images = { is_enable: this.planData.images.is_enable ? 1 : 0 }
      this.plan.products_in_player = { max_num: this.planData.products_in_player.max_num }
      this.plan.atk_songs = { max_num: this.planData.atk_songs.max_num }
      this.plan.other_brands_products = { is_enable: this.planData.other_brands_products.is_enable ? 1 : 0 }
      this.plan.my_audio = { is_enable: this.planData.my_audio.is_enable ? 1 : 0 }
      this.$service.put(url, this.plan).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updatePlan', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.features-container {
  width: 485px;
  .features-header {
    padding: 12px 16px;
    background-color: #DBE7EA;
    border-radius: 8px;
    font-size: 18px;
    font-weight: bold;
    display: flex;
    .col-name {
      width: 70%;
    }
    .col-action {
      width: 30%;
    }
  }
  .features-list {
    margin-top: 16px;
    .feature-item {
      padding: 12px 16px;
      display: flex;
      align-items: center;
      font-size: 18px;
      .col-name {
        width: 70%;
      }
      .col-action {
        width: 30%;
      }
    }
  }
}
</style>
